import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.error.cause.js";
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, unref as _unref, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createTextVNode as _createTextVNode, vShow as _vShow, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from './images/ic_refresh.png';
import _imports_1 from './images/ic_stop.png';
import _imports_2 from './images/ic_play.png';
import _imports_3 from './images/ic_del.png';

const _withScopeId = n => (_pushScopeId("data-v-01c31bb4"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "media-management"
};
const _hoisted_2 = {
  style: {
    "position": "fixed",
    "top": "-9999999999999999px"
  }
};
const _hoisted_3 = ["element-loading-text"];
const _hoisted_4 = {
  class: "table__container"
};
const _hoisted_5 = {
  class: "header"
};
const _hoisted_6 = {
  class: "header__btns"
};
const _hoisted_7 = {
  class: "table-list",
  ref: "tableWarpRef"
};
const _hoisted_8 = {
  key: 0,
  class: "progress-warp"
};
const _hoisted_9 = {
  key: 0,
  class: "progress-status"
};
const _hoisted_10 = {
  style: {
    "display": "flex",
    "justify-content": "center",
    "gap": "10px"
  }
};
const _hoisted_11 = {
  key: 1,
  class: "uploader-file-actions-btn"
};
const _hoisted_12 = ["onClick"];
const _hoisted_13 = ["onClick"];
const _hoisted_14 = ["onClick"];
const _hoisted_15 = ["onClick"];
const _hoisted_16 = {
  key: 2,
  class: "progress-status"
};
const _hoisted_17 = {
  key: 3,
  class: "uploader-file-actions-btn"
};
const _hoisted_18 = ["onClick"];
const _hoisted_19 = ["onClick"];
const _hoisted_20 = {
  key: 1,
  style: {
    "display": "flex"
  }
};
const _hoisted_21 = {
  key: 0,
  style: {
    "display": "inline-block",
    "width": "100%",
    "overflow": "hidden",
    "text-overflow": "ellipsis"
  }
};
const _hoisted_22 = {
  key: 1
};
const _hoisted_23 = {
  key: 2,
  style: {
    "display": "flex"
  }
};
const _hoisted_24 = {
  key: 0,
  class: "mg-t--10",
  style: {
    "color": "red"
  }
};
const _hoisted_25 = ["element-loading-text"];
const _hoisted_26 = {
  class: "select-file-warp"
};
const _hoisted_27 = {
  key: 0,
  class: "file"
};
const _hoisted_28 = {
  style: {
    "flex-shrink": "0"
  }
};
const _hoisted_29 = {
  class: "program-type-warp mg-t--30"
};
const _hoisted_30 = {
  class: "label"
};
const _hoisted_31 = {
  class: "infoid-warp mg-t--20"
};
const _hoisted_32 = {
  class: "label"
};
import TagType from '@/views/common/TagType/index.vue';
import Buttons from '@/components/Buttons/index.vue';
import ChunkUpload from '@/components/ChunkUpload/index.vue';
import SearchDialog from '@/views/onDemandContent/FilmReview/components/SearchDialog/index.vue';
import AddTo from '@/views/onDemandContent/FilmReview/edit.vue';
import MediaDetail from './mediaDetail.vue';
import { useI18n } from 'vue-i18n';
import { usePageConfig } from '@/utils/useComponentConfig';
import { inject, onMounted, onUnmounted, nextTick } from 'vue';
import { formValidator, messageBox } from '@/utils/validate';
import { elMessage, getTextWidth, isEmptyArray } from '@/utils';
import { useCommon } from '@/store/useCommon';
import { getMediaListApi, insertMediaApi, deleteFileApi, uploadCancelApi, getStatusByIdsApi, isUploadingApi, exportMediaApi, getFileTypeListApi, fileTranscodeApi, addMediaApi, getMediaUserNameApi, updateMediaStatusApi } from '@/api/mediaManagement';
import { debounce, fileDownload, getItemByProp } from '@/utils/tools';
import Uploader from 'simple-uploader.js';
import { getOperatorNameListApi } from '@/api/authority';
import { getCurrentTime } from '@/utils/timeFormat';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',

  setup(__props) {
    const {
      t
    } = useI18n();
    const tableRef = ref(null);
    const uploadRef = ref(null);
    const retryUploadRef = ref(null);
    const searchDialogRef = ref(null);
    const tagTypeRef = ref(null);
    const showUploadLoading = ref(false);
    const addTo = reactive({
      visible: false
    }); // 分片上传组件

    const chunkUploadRef = inject('chunkUploadRef');
    const mediaDetail = reactive({
      visible: false,
      detailInfo: {
        id: ''
      },
      mediaParams: null
    });
    const transcodeColorObj = {
      0: '#4ea8fa',
      1: '#29b87d',
      2: '#f2994a'
    };
    const searchConfig = reactive({
      size: {
        sm: 24,
        md: 12,
        lg: 8,
        xl: 6,
        xs: {}
      },
      formList: [{
        label: '关键字筛选',
        prop: 'name',
        widgetType: 'input',
        placeholder: '请输入关键字',
        maxlength: 50
      }, {
        label: '上传时间',
        prop: 'time',
        widgetType: 'date',
        placeholder: '请选择时间',
        'start-placeholder': t('开始时间'),
        'end-placeholder': t('结束时间'),
        valueFormat: 'YYYY-MM-DD',
        type: 'daterange'
      }, {
        label: '类型',
        prop: 'fileType',
        widgetType: 'Select',
        placeholder: '',
        list: [{
          label: t('全部'),
          value: ''
        }]
      }, {
        label: '上传用户',
        prop: 'userId',
        widgetType: 'Select',
        filterable: true,
        placeholder: '',
        labelKey: 'name',
        valueKey: 'id',
        list: [],
        change: value => {
          getData();
        },
        controller: () => {
          return useCommon().userData.permissionKey.indexOf('VT_MM_US') > -1;
        }
      }, {
        label: '运营商',
        prop: 'cpspid',
        widgetType: 'treeSelect',
        list: [],
        filterable: true,
        controller: () => {
          return useCommon().userData.permissionKey.indexOf('DC_CPSPID_S') > -1;
        },
        change: val => {
          sessionStorage.setItem('currentCpspid', val); // searchConfig.formData.userId = '';

          getUsernameByOperationId();
        } // props: {
        //     label: 'name',
        //     children: 'children',
        //     value: 'id',
        // }

      }, {
        label: '服务器类型',
        prop: 'serverType',
        widgetType: 'Select',
        list: [{
          label: 'S3',
          value: 'S3'
        }, {
          label: 'GS',
          value: 'GS'
        }],
        change: val => {
          searchConfig.formData.fileType = '';
          getFileTypeList(val);
          getData();
        }
      }],
      formData: {
        name: '',
        fileType: '',
        time: '',
        userId: '',
        cpspid: null,
        serverType: 'GS'
      },
      search: () => {
        tableConfig.paginationConfig.page = 1;
        getData();
      },
      reset: () => {
        tableRef.value.commonTableRef.clearSort();
        searchConfig.formData.cpspid = Number(sessionStorage.getItem('currentCpspid'));
        searchData.sortType = '';
        searchData.sortByField = '';
        searchConfig.formData.serverType = 'GS';
        sessionStorage.setItem('transcode-serverType', 'GS');
        tableConfig.paginationConfig.page = 1;

        if (currentTagtype.value == '0' && useCommon().userData.permissionKey.indexOf('VT_MM_US') > -1) {
          setUploadUserSelectDefault();
        }

        getData();
      }
    });
    const Tags = computed(() => {
      let common = [{
        type: '0',
        name: '上传中'
      }, {
        type: '1',
        name: '已上传'
      }, {
        type: '3',
        name: '已取消'
      }];
      return common;
    });
    const currentTagtypeLoading = ref(false);
    const currentTagtype = ref('0'); // 处理Tag点击事件

    const handleTagClick = tag => {
      if (currentTagtype.value == tag.type) return;
      currentTagtypeLoading.value = true;
      tableRef.value.commonTableRef.clearSort();
      tableRef.value.commonTableRef.clearSelection();
      tableConfig.paginationConfig.page = 1;
      searchData.sortType = '';
      searchData.sortByField = '';
      tableConfig.showPageBar = tag.type == '0' ? false : true;
      currentTagtype.value = tag.type;
      tableConfig.data = []; // 这一段会在点击tag后，自动切换回原来账号的userId，有点奇怪先去掉
      // if (currentTagtype.value == '0' && useCommon().userData.permissionKey.indexOf('VT_MM_US') > -1) {
      //     const item = getItemByProp(searchConfig.formList, 'userId');
      //     const findItem = item.list.find(f => f.id == useCommon().userData.id);
      //     findItem ? searchConfig.formData.userId = useCommon().userData.id : '';
      // }

      getData();
      setTimeout(() => {
        currentTagtypeLoading.value = false;
      }, 100);
    };

    const tableConfig = reactive({
      currentTagtype: '',
      data: [],
      isCardBlock: true,
      paginationConfig: usePageConfig(),
      isShowHeader: false,
      scrollbarAlwaysOn: true,
      showPageBar: false,
      headerButtonsList: [{
        label: '删除',
        type: 'danger',
        func: async () => {
          if (currentTagtype.value != '0') {
            if (!tableSelectList.value.length) return elMessage('warning', '请先勾选需要删除的数据');
            let ids = [];
            tableSelectList.value.forEach(e => {
              ids.push(e.id);
            });
            messageBox('确定删除已选数据吗?').then(async () => {
              tableConfig.config.loading = true;

              try {
                const res = await deleteFileApi({
                  idList: ids
                });

                if (res.code == '0') {
                  deleteFileList(ids);
                  tableRef.value.commonTableRef.clearSelection();
                  elMessage('success', '删除成功');
                  getData();
                } else {
                  tableConfig.config.loading = false;
                }
              } catch (error) {
                tableConfig.config.loading = false;
              }
            });
          }

          if (currentTagtype.value == '0') {
            let ids = [];
            tableSelectList.value.forEach(e => {
              ids.push(e.id);
            }); // 判断上传中勾选的文件是否在请求列表里 (防止上传中列表更新了 勾选列表还保留上传完的值)

            ids = ids.filter(f => {
              return tableConfig.data.find(tableItem => {
                if (tableItem.id == f) {
                  return true;
                }

                return false;
              });
            });

            if (ids.length) {
              messageBox('确定删除已选数据吗?').then(async () => {
                tableConfig.config.loading = true;

                try {
                  const res = await deleteFileApi({
                    idList: ids
                  });

                  if (res.code == '0') {
                    deleteFileList(ids);
                    tableRef.value.commonTableRef.clearSelection();
                    elMessage('success', '删除成功');
                    getData();
                  } else {
                    tableConfig.config.loading = false;
                  }
                } catch (error) {
                  console.log(error);
                  tableConfig.config.loading = false;
                }
              });
            } else {
              tableRef.value.commonTableRef.clearSelection();
              return elMessage('warning', '请先勾选需要删除的数据');
            }
          }
        },
        controller: config => {
          config.disabled = !tableSelectList.value.length ? true : false;
          return true;
        }
      }, {
        label: '上传',
        func: () => {
          chunkUploadRef.value && chunkUploadRef.value.clearSelectFile();
          dialogConfig.visible = true;
        },
        controller: () => {
          return currentTagtype.value == '0';
        }
      }, {
        label: '导出',
        func: async () => {
          if (!tableConfig.data.length) return;
          tableConfig.config.loading = true;

          try {
            let ids = [];
            tableSelectList.value.forEach(e => {
              ids.push(e.id);
            });
            let userId = useCommon().userData.permissionKey.indexOf('VT_MM_US') > -1 ? searchConfig.formData.userId : useCommon().userData.id;
            const res = await exportMediaApi({
              ids,
              userId,
              cpspid: searchConfig.formData.cpspid,
              serverType: searchConfig.formData.serverType
            });
            fileDownload(res.data, res.processData.fileName, res.processData.contentType);
          } catch (error) {}

          tableConfig.config.loading = false;
        },
        controller: () => {
          return currentTagtype.value == '1';
        }
      }],
      config: {
        loading: false
      },
      'row-key': row => {
        return row.id;
      }
    });
    const columnConfig = reactive({
      columnList: [{
        label: '',
        prop: '',
        type: 'selection',
        'reserve-selection': true
      }, {
        label: '序号',
        prop: 'serialNumber',
        minWidth: 65
      }, {
        label: '信息源ID',
        prop: 'sourceId',
        width: 160,
        cellSlot: true,
        sortable: 'custom'
      }, {
        label: '文件名称',
        prop: 'fileName',
        width: 300,
        sortable: 'custom'
      }, {
        label: '类型',
        prop: 'fileType',
        minWidth: 100,
        sortable: 'custom',
        // cellSlot: true,
        formatter: val => val && val.toLowerCase()
      }, {
        label: '文件大小',
        prop: 'fileSize',
        minWidth: 120,
        sortable: 'custom',
        formatter: val => {
          return val && Uploader.utils.formatSize(val);
        }
      }, {
        label: '进度',
        prop: 'uploadProgress_c',
        minWidth: 300,
        cellSlot: true,
        controller: row => {
          return currentTagtype.value == '0';
        }
      }, {
        label: '是否转码',
        prop: 'transcodeStatus',
        width: 170,
        sortable: 'custom',
        cellSlot: true,
        showOverflowTooltip: false,
        controller: row => {
          return currentTagtype.value == '1';
        }
      }, {
        label: '上传用户',
        prop: 'userName',
        width: 120
      }, {
        label: '上传时间',
        prop: 'createTime',
        width: 170,
        sortable: 'custom',
        formatter: val => val && getCurrentTime(val)
      }, {
        label: '操作',
        prop: '',
        widgetType: 'buttons',
        fixed: 'right',
        width: 260,
        showOverflowTooltip: false,
        buttonsList: [{
          label: 'Add to',
          func: row => {
            mediaDetail.mediaParams = {
              url: row.url,
              type: ['srt', 'vtt', 'ass', 'stl', 'sbv'].includes(row.fileType) ? 'subtitle' : 'movie',
              programType: row.programType,
              name: row.fileName,
              id: row.id
            };
            addTo.visible = true;
          },
          controller: row => {
            return currentTagtype.value == '1' && !row.sourceId;
          }
        }, {
          label: '转码',
          func: debounce(async row => {
            try {
              tableConfig.config.loading = true;
              const {
                id,
                fileIdentifier,
                transcodeUrl
              } = row;
              const res = await fileTranscodeApi({
                fileIdentifier,
                transcodeUrl
              });

              if (res.code == '0') {
                elMessage('success', '操作成功');
                getData();
              } else {
                tableConfig.config.loading = false;
              }
            } catch (error) {
              tableConfig.config.loading = false;
            }
          }, 200),
          controller: row => {
            return currentTagtype.value == '1' && row.transcodeStatus == 0;
          }
        }, {
          label: '详情',
          func: row => {
            mediaDetail.visible = true;
            mediaDetail.detailInfo.id = row.id;
          },
          controller: row => {
            return currentTagtype.value == '1';
          }
        }, {
          label: '重传',
          func: async row => {
            selectFileRetry(row.fileIdentifier, row, false);
          },
          controller: row => {
            return currentTagtype.value == '3';
          }
        }, {
          label: '删除',
          func: row => {
            messageBox('确定删除这条数据吗?').then(async () => {
              tableConfig.config.loading = true;

              try {
                const res = await deleteFileApi({
                  idList: [row.id]
                });

                if (res.code == '0') {
                  deleteFileList([row.id]);
                  elMessage('success', '删除成功');
                  getData();
                } else {
                  tableConfig.config.loading = false;
                }
              } catch (error) {
                console.log(error);
                tableConfig.config.loading = false;
              }
            });
          },
          controller: row => {
            return true;
          }
        }]
      }]
    });
    const dialogConfig = reactive({
      visible: false,
      action: 'movie',
      config: {
        title: '上传'
      },
      formData: {
        file: [],
        sourceId: '',
        infoId: 'TMDB',
        programType: 'movie'
      },
      rules: {
        file: [{
          required: true,
          validator: (rules, value, callback) => {
            if (isEmptyArray(value)) {
              callback(new Error(t('请选择文件')));
            } else {
              callback();
            }
          },
          trigger: 'blur'
        }]
      },
      confirm: done => {
        formValidator(uploadRef.value).then(async () => {
          showUploadLoading.value = true;

          try {
            // 本地存储serverType，用于计算md5时判断当前服务器类型，gs类型不进行分块
            sessionStorage.setItem('transcode-serverType', searchConfig.formData.serverType); // 走组件的computeMD5方法

            await chunkUploadRef.value.computeMD5(chunkUploadRef.value.selectFile[0]);
            let postData = {
              cpspId: useCommon().userData.cpspid || 0,
              sourceId: dialogConfig.formData.sourceId.trim(),
              programType: dialogConfig.formData.programType,
              userId: useCommon().userData.id,
              fileName: chunkUploadRef.value.selectFile[0].fileName.substring(0, chunkUploadRef.value.selectFile[0].fileName.lastIndexOf('.')),
              fileType: chunkUploadRef.value.selectFile[0].fileName.substring(chunkUploadRef.value.selectFile[0].fileName.lastIndexOf(".") + 1).toLowerCase(),
              fileSize: chunkUploadRef.value.selectFile[0].fileSize,
              fileIdentifier: chunkUploadRef.value.selectFile[0].uniqueIdentifier,
              serverType: searchConfig.formData.serverType
            };
            const {
              code,
              data: mediaId
            } = await addMediaApi(postData);

            if (code == 0) {
              let formData = new FormData();
              formData.append('file', chunkUploadRef.value.selectFile[0].file); // post接口需要什么参数就写在这里

              chunkUploadRef.value.fileParams = {
                //file: chunkUploadRef.value.selectFile[0].file,
                cpspId: useCommon().userData.cpspid ?? 0,
                programType: dialogConfig.formData.programType,
                mediaId,
                totalChunks: chunkUploadRef.value.selectFile[0].totalChunks,
                totalSize: chunkUploadRef.value.selectFile[0].fileSize,
                fileName: chunkUploadRef.value.selectFile[0].fileName.substring(0, chunkUploadRef.value.selectFile[0].fileName.lastIndexOf('.')),
                fileType: chunkUploadRef.value.selectFile[0].fileName.substring(chunkUploadRef.value.selectFile[0].fileName.lastIndexOf(".") + 1).toLowerCase(),
                identifier: chunkUploadRef.value.selectFile[0].uniqueIdentifier,
                serverType: searchConfig.formData.serverType
              };
              chunkUploadRef.value.selectFile[0].id = mediaId; // 这里开始调用chunkUpload组件,检查分片get /api/mediaAsset/uploadFile，再上传分片
              // serverType为gs的不进行分片，s3进行分片

              chunkUploadRef.value.addFileList();
              dialogConfig.visible = false; // 成功后更新数据列表

              getData();
            }
          } catch (error) {
            console.log('681err', error);
          } finally {
            done();
            showUploadLoading.value = false;
          }
        }, () => done());
      },
      close: () => {
        setTimeout(() => {
          chunkUploadRef.value && chunkUploadRef.value.fileReaderRef.example && chunkUploadRef.value.fileReaderRef.example.abort();
        }, 200);
      }
    }); // 上传弹窗确认事件

    const createUploadFile = async done => {
      // 先调用接口判断创建的上传文件是否在上传列表或取消列表中
      let res;

      try {
        await chunkUploadRef.value.computeMD5(chunkUploadRef.value.selectFile[0]);
        res = await isUploadingApi({
          identifier: chunkUploadRef.value.selectFile[0].uniqueIdentifier,
          userId: useCommon().userData.id
        });
      } catch (error) {
        console.log(error);
        done();
        showUploadLoading.value = false;
        return elMessage('error', error.msg);
      }

      if (res.data == '1') {
        elMessage('warning', '该文件已在上传列表中');
        showUploadLoading.value = false;
        done();
        return;
      } else if (res.data == '2') {
        elMessage('warning', '该文件已在取消列表中');
        showUploadLoading.value = false;
        done();
        return;
      } else {
        // 不在上传列表或取消列表中 调用信息入库接口
        let insertMediaParams = {
          sourceId: dialogConfig.formData.sourceId,
          // programType: /(.*)S[0-9]{2,3}E[0-9]{2,3}(.*)/.test(chunkUploadRef.value.selectFile[0].fileName) ? 1 : 0,
          programType: dialogConfig.formData.programType,
          // sourceType: dialogConfig.formData.infoId == 'IMDB' ? 0 : dialogConfig.formData.infoId == 'TMDB' ? 1 : dialogConfig.formData.infoId == 'ARAB' ? 2 : '',
          fileName: chunkUploadRef.value.selectFile[0].fileName.substring(0, chunkUploadRef.value.selectFile[0].fileName.lastIndexOf('.')),
          fileType: chunkUploadRef.value.selectFile[0].fileName.substring(chunkUploadRef.value.selectFile[0].fileName.lastIndexOf(".") + 1).toLowerCase(),
          fileSize: chunkUploadRef.value.selectFile[0].fileSize,
          fileIdentifier: chunkUploadRef.value.selectFile[0].uniqueIdentifier,
          isReUpload: 0,
          cpspId: useCommon().userData.cpspid || 0,
          userId: useCommon().userData.id
        };

        try {
          const res = await insertMediaApi(insertMediaParams);

          if (res.code == '0') {
            chunkUploadRef.value.fileParams = {
              sourceId: dialogConfig.formData.sourceId,
              cpspid: useCommon().userData.cpspid || 0,
              userId: useCommon().userData.id,
              filename: chunkUploadRef.value.selectFile[0].fileName.substring(0, chunkUploadRef.value.selectFile[0].fileName.lastIndexOf('.')),
              id: res.data,
              fileType: chunkUploadRef.value.selectFile[0].fileName.substring(chunkUploadRef.value.selectFile[0].fileName.lastIndexOf(".") + 1).toLowerCase(),
              // programType: /(.*)S[0-9]{2,3}E[0-9]{2,3}(.*)/.test(chunkUploadRef.value.selectFile[0].fileName) ? 1 : 0,
              programType: dialogConfig.formData.programType
            };
            chunkUploadRef.value.selectFile[0].id = res.data;
            chunkUploadRef.value.addFileList();
            dialogConfig.visible = false;
            showUploadLoading.value = false; // 成功后更新数据列表

            getData();
          }
        } catch (error) {}

        done();
      }
    };

    const options = reactive({
      dialogOptions: {
        infoId: dialogConfig.formData.infoId
      }
    });
    const programType = ref('movie');
    const searchDialogConfig = reactive({
      visible: false,
      config: {
        title: '信息源搜索'
      },
      confirm: () => {
        const {
          detailMainInfo
        } = searchDialogRef.value.data;

        if (detailMainInfo) {
          dialogConfig.formData.sourceId = detailMainInfo.id;
        }

        searchDialogConfig.visible = false;
      }
    }); // 上传按钮选择文件点击事件

    const selectFile = () => {
      chunkUploadRef.value.uploadBtnRef.$el.click();
      chunkUploadRef.value.uploaderRef.fileList.forEach(i => {
        i.dynamicData ? '' : i.cancel();
      });
    };

    const timer = ref([]);
    const statusArr = ref([]);

    const getData = async () => {
      clearTimerId(); // chunkUploadRef.value && chunkUploadRef.value.clearTimer();
      // retryUploadRef.value && retryUploadRef.value.clearTimer();

      statusArr.value = [];
      console.log('searchConfig.formData', searchConfig.formData);
      console.log('currentTagtype.value', currentTagtype.value);

      if (useCommon().userData.permissionKey.indexOf('VT_MM_US') > -1 && !searchConfig.formData.userId && currentTagtype.value == '0') {
        tableConfig.data = [];
        tableConfig.config.loading = false;
        return;
      }

      ;
      !tableConfig.config.loading ? tableConfig.config.loading = true : '';

      try {
        let params = {
          fileName: searchConfig.formData.name,
          fileType: searchConfig.formData.fileType,
          uploadStartTime: searchConfig.formData.time[0],
          uploadEndTime: searchConfig.formData.time[1],
          pageNo: tableConfig.paginationConfig.page,
          pageSize: currentTagtype.value == '0' ? 99999 : tableConfig.paginationConfig.limit,
          userId: useCommon().userData.permissionKey.indexOf('VT_MM_US') > -1 ? searchConfig.formData.userId : useCommon().userData.id,
          status: currentTagtype.value,
          cpspid: searchConfig.formData.cpspid,
          serverType: searchConfig.formData.serverType,
          ...searchData
        };
        const res = await getMediaListApi(params);

        if (res.code == '0') {
          tableConfig.data = formatterData(res.data.records);
          tableConfig.paginationConfig.total = res.data.total;
          tableSelectList.value.forEach(row => {
            tableRef.value.commonTableRef.toggleRowSelection(row, true);
          });
        }
      } catch (error) {
        console.log(833, error);
      }

      tableConfig.config.loading = false;
    }; // 格式化后端返回数据


    const formatterData = data => {
      // 如果是上传中的列表数据 先找到上传组件中的上传列表数据id是否对应后端返回数据 是的话把实例一些方法函和参数数赋值给返回数据
      if (currentTagtype.value == '0') {
        if (chunkUploadRef.value.fileList.length) {
          chunkUploadRef.value.fileList.forEach(chunkFileItem => {
            !chunkFileItem.handlePaused && chunkFileItem.resume();
            const findIndex = data.findIndex(f => f.id == chunkFileItem.id);

            if (findIndex > -1) {
              try {
                chunkFileItem.createTime = data[findIndex].createTime;
                chunkFileItem.userName = data[findIndex].userName;
                chunkFileItem.sourceId = data[findIndex].sourceId;
                chunkFileItem.sourceType = data[findIndex].sourceType;
                chunkFileItem.dynamicData = true; // chunkFileItem.uploadProgress = data[findIndex].uploadProgress || 0;
                // chunkFileItem.uploadProgress_c = data[findIndex].uploadProgress || 0;

                chunkFileItem.uploadProgress = data[findIndex].uploadProgress || 0;
                chunkFileItem.uploadProgress_c = Math.floor(chunkFileItem.progress() * 100);
                data[findIndex] = chunkFileItem; // isResume && data[findIndex].resume();
                //   chunkFileItem.ignored = false;
                // !chunkFileItem.handlePaused && chunkFileItem.resume();
              } catch (error) {
                console.log(chunkFileItem, error);
              }
            }
          });
          data.forEach((item, index) => item.serialNumber = index + 1);
          return data;
        } else {
          data.forEach((item, index) => item.serialNumber = index + 1);
          return data;
        }
      } else {
        data.forEach((item, index) => item.serialNumber = index + 1);
        return data;
      }
    }; // 表格复选框选中数据


    const tableSelectList = ref([]); // 表格复选框选中事件函数

    const handleSelectionChange = val => {
      tableSelectList.value = val;
    };

    const setOptionsBtnColumnWidth = width => {
      const findItem = columnConfig.columnList.find(item => item.label == '操作');
      findItem ? findItem.width = width : '';
    }; // const languageOptions = ref([])
    // // 获取所有语言
    // const getAllLanguages = async () => {
    //     const res = await useVodLanguages() as any
    //     languageOptions.value = res
    // }
    // provide('languageOptions', languageOptions)
    // const showSearchDialogConfig = () => {
    //     if (!chunkUploadRef.value.selectFile.length) return elMessage('warning', '请先选择文件');
    //     // console.log(chunkUploadRef.value.selectFile[0].fileName);
    //     // 校验上传文件名是电影还是电视剧
    //     /(.*)S[0-9]{2,3}E[0-9]{2,3}(.*)/.test(chunkUploadRef.value.selectFile[0].fileName) ? programType.value = 1 : programType.value = 0
    //     options.dialogOptions.infoId = dialogConfig.formData.infoId
    //     searchDialogConfig.visible = true
    // }


    const onFileItemRemove = row => {
      messageBox('确定取消这条数据吗?').then(async () => {
        try {
          tableConfig.config.loading = true;
          const res = await uploadCancelApi({
            id: row.id,
            status: 3
          });

          if (res.code == '0') {
            elMessage('success', '操作成功');
            const findIndex = chunkUploadRef.value.fileList.findIndex(f => f.id == row.id);

            if (findIndex > -1) {
              chunkUploadRef.value.fileList[findIndex].cancel();
              chunkUploadRef.value.fileList.splice(findIndex, 1);
            }

            getData();
          } else {
            tableConfig.config.loading = false;
          }
        } catch (error) {
          tableConfig.config.loading = false;
        }
      });
    }; // 暂停=>2|| 刷新=>1 按钮的点击事件


    const handleBtnClick = async (handlePause, row, type) => {
      row.handlePaused = true;
      type == 1 ? row.pause() : row.retry();

      try {
        const {
          code,
          data
        } = await updateMediaStatusApi({
          id: row.id,
          status: type
        });

        if (code == 0) {
          //row.dynamicData = true;
          let file = row.file;
          chunkUploadRef.value.fileList.push(file);
          chunkUploadRef.value.fileParams = {
            sourceId: file.sourceId,
            cpspid: useCommon().userData.cpspid || 0,
            userId: useCommon().userData.id,
            filename: file.filename,
            id: row.id,
            fileType: file.fileType,
            // programType: /(.*)S[0-9]{2,3}E[0-9]{2,3}(.*)/.test(file.fileName) ? 1 : 0,
            programType: file.programType
          };
          tagTypeRef.value.activeType = '0';
          currentTagtype.value = '0'; //getData();
        }
      } catch (error) {}
    }; // 重传 上传组件选择完文件并校验md5成功后的响应事件


    const addFile = async data => {
      tableConfig.config.loading = true;
      const {
        file,
        isCancel,
        isRetry
      } = data; // 这里只有重新上传或者取消上传

      let status = isRetry ? 0 : 3; // 是否是已取消列表里的重传
      // let insertMediaParams = {
      //     sourceId: file.sourceId,
      //     // programType: /(.*)S[0-9]{2,3}E[0-9]{2,3}(.*)/.test(file.fileName) ? 1 : 0,
      //     programType: file.programType,
      //     // sourceType: dialogConfig.formData.infoId == 'IMDB' ? 0 : dialogConfig.formData.infoId == 'TMDB' ? 1 : dialogConfig.formData.infoId == 'ARAB' ? 2 : '',
      //     fileName: file.fileName,
      //     fileType: file.fileType,
      //     fileSize: file.fileSize,
      //     fileIdentifier: file.fileIdentifier,
      //     isReUpload: 1,
      //     id: file.id,
      //     cpspid: useCommon().userData.cpspid || 0,
      //     userId: useCommon().userData.id
      // }

      let params = {
        id: file.id,
        status
      };

      try {
        const res = await updateMediaStatusApi(params);

        if (res.code == '0') {
          file.dynamicData = true;
          chunkUploadRef.value.fileList.push(file);
          chunkUploadRef.value.fileParams = {
            sourceId: file.sourceId,
            cpspid: useCommon().userData.cpspid || 0,
            userId: useCommon().userData.id,
            filename: file.filename,
            id: res.data,
            fileType: file.fileType,
            // programType: /(.*)S[0-9]{2,3}E[0-9]{2,3}(.*)/.test(file.fileName) ? 1 : 0,
            programType: file.programType
          };
          tagTypeRef.value.activeType = '0';
          currentTagtype.value = '0';
          getData();
        } else {
          tableConfig.config.loading = false;
        }
      } catch (error) {
        tableConfig.config.loading = false;
      }
    }; // 根据运营商获取上传用户下拉列表


    const getUsernameByOperationId = async () => {
      // 判断是否有上传用户下拉权限
      if (useCommon().userData.permissionKey.indexOf('VT_MM_US') > -1) {
        // 有则先获取上传用户下拉数据
        tableConfig.config.loading = true;

        try {
          const res = await getMediaUserNameApi();

          if (res.code == '0') {
            let item = getItemByProp(searchConfig.formList, 'userId');
            item.list = [{
              name: t('全部'),
              id: ''
            }, ...res.data];
            const findItem = item.list.find(f => f.id == useCommon().userData.id);

            if (currentTagtype.value == '0' && findItem) {
              searchConfig.formData.userId = useCommon().userData.id;
            } else {
              searchConfig.formData.userId = '';
            }
          }
        } catch (error) {}
      } // 没有直接获取table列表数据


      getData();
    }; // 重新选择文件上传


    const selectFileRetry = (md5, row, isCancel) => {
      try {
        console.log('row', row); // 清空上传组件实例上传列表数据 否则再次选择相同文件不会进入上传组件onFileAdded事件
        // retryUploadRef.value.uploaderRef.fileList.forEach(i => i.cancel())

        retryUploadRef.value.isRetry = true;
        retryUploadRef.value.retryFileMd5 = md5;
        retryUploadRef.value.retryFileParams = row;
        retryUploadRef.value.retryFileParams.isCancel = isCancel;
        retryUploadRef.value.retryFileParams.cpspid = useCommon().userData.cpspid || 0;
        retryUploadRef.value.retryFileParams.userId = useCommon().userData.id;
        retryUploadRef.value.retryFileParams.mediaId = row.id; // retryUploadRef.value.retryFileParams.programType = /(.*)S[0-9]{2,3}E[0-9]{2,3}(.*)/.test(row.fileName) ? 1 : 0

        retryUploadRef.value.retryFileParams.programType = row.programType;
        retryUploadRef.value.uploadBtnRef.$el.click();
      } catch (error) {
        console.log(error);
      }
    }; // 删除数据是否在upload组件上传列表中(在的话先终止上传请求,再删除数据)


    const deleteFileList = ids => {
      if (chunkUploadRef.value.fileList.length) {
        ids.forEach(e => {
          const findIndex = chunkUploadRef.value.fileList.findIndex(f => f.id == e);

          if (findIndex > -1) {
            chunkUploadRef.value.fileList[findIndex].pause();
            chunkUploadRef.value.fileList.splice(findIndex, 1);
          }
        });
      }
    }; // 获取文件类型下拉数据


    const getFileTypeList = async serverType => {
      const res = await getFileTypeListApi(serverType);

      if (res.code == '0') {
        let item = getItemByProp(searchConfig.formList, 'fileType');
        item.list = [...item.list, ...res.data.map(i => {
          return {
            label: i,
            value: i
          };
        })];
      }
    }; // 更新数据


    const updateList = () => {
      getData();
    }; // 排序用到参数


    const searchData = reactive({
      sortType: '',
      sortByField: ''
    }); // 表格排序

    const handleSortChange = debounce(async params => {
      if (params.order) {
        const sortType = params.order.replace('ending', '');
        searchData.sortType = sortType;
        searchData.sortByField = params.prop;
        getData();
      } else {
        searchData.sortType = '';
        searchData.sortByField = '';
        getData();
      }
    }, 200); //  内容超出时显示提示

    const tipDisabled = ref(false);

    const showTextTip = e => {
      const target = e.target;
      const width = getTextWidth(target.innerText, {
        fontSize: '14px'
      });
      tipDisabled.value = target.offsetWidth < width;
    }; // 格式化运营商数据


    const getOptions = list => {
      let newList = [];
      list.forEach((item, index) => {
        newList.push({
          value: item.id,
          label: item.name,
          children: item.children != null && item.children.length > 0 ? getOptions(item.children) : null
        });
      });
      return newList;
    }; // 获取运营商


    const getOperatorList = async () => {
      if (useCommon().userData.permissionKey.indexOf('DC_CPSPID_S') > -1) {
        try {
          const res = await getOperatorNameListApi();

          if (res.code == '0') {
            let item = getItemByProp(searchConfig.formList, 'cpspid');
            item.list = getOptions(res.data);
          }
        } catch (error) {}
      }

      let currentCpspid = useCommon().userData.permissionKey.indexOf('DC_CPSPID_S') > -1 ? sessionStorage.getItem('currentCpspid') : useCommon().userData.cpspid || 0;
      searchConfig.formData.cpspid = currentCpspid ? Number(currentCpspid) : useCommon().userData.cpspid || 0;
      sessionStorage.setItem('currentCpspid', String(searchConfig.formData.cpspid));
    }; // 设置上传用户默认选中项


    const setUploadUserSelectDefault = () => {
      const item = getItemByProp(searchConfig.formList, 'userId');
      const findItem = item.list.find(f => f.id == useCommon().userData.id);
      findItem ? searchConfig.formData.userId = useCommon().userData.id : searchConfig.formData.userId = '';
    };

    const checkFileStates = () => {
      clearTimerId();

      if (currentTagtype.value == '0') {
        tableConfig.data.forEach(e => {
          if (e.uploadProgress_c == 100) {
            statusArr.value.push(e.id);
          }
        });

        if (statusArr.value.length) {
          let timerId = setInterval(async () => {
            try {
              const res = await getStatusByIdsApi({
                ids: statusArr.value
              });

              if (res.code == '0') {
                res.data.length && res.data.forEach(item => {
                  if (item.status == 1 || item.status == 3) {
                    clearTimerId();
                    statusArr.value = [];
                    getData();
                    return;
                  }
                });
              } else {
                clearTimerId();
                getData();
                return;
              }
            } catch (error) {
              clearTimerId();
              getData();
              return;
            }
          }, 3000);
          timer.value.push(timerId);
        }
      }
    };

    onMounted(async () => {
      getFileTypeList('GS');
      await getOperatorList();
      getUsernameByOperationId(); // window.addEventListener("beforeunload", (e) => {
      //     e = e || window.event;
      //     // 兼容IE8和Firefox 4之前的版本
      //     if (e) {
      //         e.returnValue = '关闭提示';
      //     }
      //     // Chrome, Safari, Firefox 4+, Opera 12+ , IE 9+
      //     return '关闭提示';
      // });

      retryUploadRef.value.fileUploadSuccess = () => {
        // getData();
        checkFileStates();
      };

      chunkUploadRef.value.fileUploadSuccess = () => {
        // getData();
        checkFileStates();
      };
    });

    const clearTimerId = () => {
      timer.value.forEach(e => {
        clearInterval(e);
      });
    };

    onUnmounted(() => {
      clearTimerId(); // chunkUploadRef.value && chunkUploadRef.value.clearTimer();
      // retryUploadRef.value && retryUploadRef.value.clearTimer();
    });
    watch(() => chunkUploadRef.value.selectFile, val => {
      if (chunkUploadRef.value && val) {
        dialogConfig.formData.file = val;
        uploadRef.value && uploadRef.value.validateField('file');
      }
    }, {
      immediate: true,
      deep: true
    });
    watch(() => dialogConfig.visible, val => {
      if (val) {
        dialogConfig.formData.sourceId = '';
        setTimeout(() => {
          uploadRef.value && uploadRef.value.clearValidate();
        }, 100);
      }
    }); // watch(() => searchDialogConfig.visible, async (val) => {
    //     if (val) {
    //         await getAllLanguages()
    //     }
    // })

    const filterColumnItemChange = () => {
      nextTick(() => {
        tableRef.value && tableRef.value.commonTableRef.doLayout();
      });
    };

    return (_ctx, _cache) => {
      const _component_search_form = _resolveComponent("search-form");

      const _component_TableColumnOptionBtn = _resolveComponent("TableColumnOptionBtn");

      const _component_el_progress = _resolveComponent("el-progress");

      const _component_MPopper = _resolveComponent("MPopper");

      const _component_column = _resolveComponent("column");

      const _component_common_table = _resolveComponent("common-table");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_radio = _resolveComponent("el-radio");

      const _component_el_radio_group = _resolveComponent("el-radio-group");

      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form = _resolveComponent("el-form");

      const _component_MDialog = _resolveComponent("MDialog");

      const _directive_crosswiseScroll = _resolveDirective("crosswiseScroll");

      const _directive_loading = _resolveDirective("loading");

      return _openBlock(), _createElementBlock(_Fragment, null, [_withDirectives(_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(ChunkUpload, {
        ref_key: "retryUploadRef",
        ref: retryUploadRef,
        onAddFile: addFile
      }, null, 512)]), _createVNode(_component_search_form, {
        size: searchConfig.size,
        gutter: 30,
        "form-list": searchConfig.formList,
        "form-data": searchConfig.formData,
        onSearch: searchConfig.search,
        onReset: searchConfig.reset
      }, null, 8, ["size", "form-list", "form-data", "onSearch", "onReset"]), _withDirectives((_openBlock(), _createElementBlock("div", {
        class: "content__container mg-b--15",
        "element-loading-text": _unref(t)('文件MD5校验中 请稍后...')
      }, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(TagType, {
        ref_key: "tagTypeRef",
        ref: tagTypeRef,
        modelValue: _unref(Tags),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(Tags) ? Tags.value = $event : null),
        onOnTagClick: handleTagClick
      }, null, 8, ["modelValue"]), _createElementVNode("div", _hoisted_6, [_createVNode(Buttons, {
        "buttons-list": tableConfig.headerButtonsList
      }, null, 8, ["buttons-list"]), !currentTagtypeLoading.value ? (_openBlock(), _createBlock(_component_TableColumnOptionBtn, {
        key: 0,
        "column-list": columnConfig.columnList,
        onFilterColumnItemChange: filterColumnItemChange
      }, null, 8, ["column-list"])) : _createCommentVNode("", true)])])), [[_directive_crosswiseScroll]]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_common_table, {
        dynamicOption: "",
        onSetOptionsBtnColumnWidth: setOptionsBtnColumnWidth,
        ref_key: "tableRef",
        ref: tableRef,
        style: {
          "width": "100%"
        },
        "table-config": tableConfig,
        "pagination-config": tableConfig.paginationConfig,
        render: getData,
        onSelectionChange: handleSelectionChange,
        onSortChange: _unref(handleSortChange)
      }, {
        tableunder: _withCtx(() => [currentTagtype.value == '0' ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(_ctx.$t('Tip: Please do not refresh the page during uploading, otherwise the upload will be cancelled!')), 1)) : _createCommentVNode("", true)]),
        default: _withCtx(() => [_createVNode(_component_column, {
          "column-list": columnConfig.columnList
        }, {
          cellSlot: _withCtx(scope => [scope.column.property == 'uploadProgress_c' ? (_openBlock(), _createElementBlock("div", _hoisted_8, [scope.row.dynamicData ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("span", null, _toDisplayString(scope.row.paused ? _unref(t)('已停止') : scope.row.isUploading() ? _unref(t)('上传中...') : scope.row.error ? _unref(t)('上传失败') : scope.row.uploadProgress_c == 100 ? _unref(t)('上传成功') : _unref(t)('等待上传')), 1), _createElementVNode("span", null, _toDisplayString(`${_unref(Uploader).utils.formatSize(scope.row.averageSpeed)} / s`), 1), _createElementVNode("span", null, _toDisplayString(` (${scope.row.uploadProgress_c > scope.row.uploadProgress || scope.row.uploadProgress == 100 ? scope.row.uploadProgress_c : scope.row.uploadProgress}%)`), 1)]), _createVNode(_component_el_progress, {
            "show-text": false,
            "text-inside": false,
            color: "#4EA8FA",
            "stroke-width": 12,
            percentage: scope.row.uploadProgress_c > scope.row.uploadProgress || scope.row.uploadProgress == 100 ? scope.row.uploadProgress_c : scope.row.uploadProgress,
            status: "success"
          }, null, 8, ["percentage"])])) : _createCommentVNode("", true), scope.row.dynamicData ? (_openBlock(), _createElementBlock("div", _hoisted_11, [scope.row.error && scope.row.uploadProgress_c != 100 ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: _imports_0,
            onClick: $event => {
              scope.row.handlePaused = false;
              scope.row.retry();
            }
          }, null, 8, _hoisted_12)) : _createCommentVNode("", true), (!scope.row.paused || scope.row.isUploading()) && !scope.row.error && scope.row.uploadProgress_c != 100 ? (_openBlock(), _createElementBlock("img", {
            key: 1,
            src: _imports_1,
            onClick: $event => {
              scope.row.handlePaused = true;
              scope.row.pause();
            }
          }, null, 8, _hoisted_13)) : _createCommentVNode("", true), scope.row.paused && scope.row.uploadProgress_c != 100 ? (_openBlock(), _createElementBlock("img", {
            key: 2,
            src: _imports_2,
            onClick: $event => {
              scope.row.handlePaused = false;
              scope.row.resume();
            }
          }, null, 8, _hoisted_14)) : _createCommentVNode("", true), scope.row.uploadProgress_c != 100 ? (_openBlock(), _createElementBlock("img", {
            key: 3,
            src: _imports_3,
            onClick: $event => onFileItemRemove(scope.row)
          }, null, 8, _hoisted_15)) : _createCommentVNode("", true)])) : _createCommentVNode("", true), !scope.row.dynamicData ? (_openBlock(), _createElementBlock("div", _hoisted_16, [_createElementVNode("span", null, _toDisplayString(scope.row.uploadProgress == 100 ? _unref(t)('上传成功') : _unref(t)('已停止')), 1), _createElementVNode("span", null, _toDisplayString(` (${scope.row.uploadProgress_c > scope.row.uploadProgress || scope.row.uploadProgress == 100 ? scope.row.uploadProgress_c : scope.row.uploadProgress}%)`), 1), _createVNode(_component_el_progress, {
            "show-text": false,
            "text-inside": false,
            color: "#4EA8FA",
            "stroke-width": 12,
            percentage: scope.row.uploadProgress_c > scope.row.uploadProgress || scope.row.uploadProgress == 100 ? scope.row.uploadProgress_c : scope.row.uploadProgress,
            status: "success"
          }, null, 8, ["percentage"])])) : _createCommentVNode("", true), !scope.row.dynamicData ? (_openBlock(), _createElementBlock("div", _hoisted_17, [scope.row.uploadProgress_c != 100 ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: _imports_2,
            onClick: $event => selectFileRetry(scope.row.fileIdentifier, scope.row, false)
          }, null, 8, _hoisted_18)) : _createCommentVNode("", true), scope.row.uploadProgress_c != 100 ? (_openBlock(), _createElementBlock("img", {
            key: 1,
            src: _imports_3,
            onClick: $event => onFileItemRemove(scope.row)
          }, null, 8, _hoisted_19)) : _createCommentVNode("", true)])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), scope.column.property == 'sourceId' ? (_openBlock(), _createElementBlock("div", _hoisted_20, [scope.row.sourceId ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(scope.row.sourceId + ` (${scope.row.sourceId.includes('tt') ? 'IMDB' : scope.row.sourceId.includes('ar') ? 'ARAB' : 'TMDB'})`), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_22, "--"))])) : _createCommentVNode("", true), scope.column.property == 'transcodeStatus' ? (_openBlock(), _createElementBlock("div", _hoisted_23, [_createVNode(_component_MPopper, {
            "popper-style": "padding: 5px 11px; min-width: 10px;",
            disabled: tipDisabled.value,
            placement: "top",
            trigger: "hover",
            content: scope.row.transcodeStatus == 0 ? _unref(t)('未转码') : scope.row.transcodeStatus == 1 ? _unref(t)('已转码') : scope.row.transcodeStatus == 2 ? _unref(t)('转码中') : scope.row.transcodeStatus == 3 ? _unref(t)('无需转码') : '--'
          }, {
            reference: _withCtx(() => [_createElementVNode("span", {
              onMouseover: showTextTip,
              style: _normalizeStyle(['color:' + transcodeColorObj[scope.row.transcodeStatus], {
                "display": "inline-block",
                "width": "100%",
                "white-space": "nowrap",
                "overflow": "hidden",
                "text-overflow": "ellipsis"
              }])
            }, _toDisplayString(scope.row.transcodeStatus == 0 ? _unref(t)('未转码') : scope.row.transcodeStatus == 1 ? _unref(t)('已转码') : scope.row.transcodeStatus == 2 ? _unref(t)('转码中') : scope.row.transcodeStatus == 3 ? _unref(t)('无需转码') : '--'), 37)]),
            _: 2
          }, 1032, ["disabled", "content"])])) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["column-list"])]),
        _: 1
      }, 8, ["table-config", "pagination-config", "onSortChange"])], 512)])), [[_directive_loading, tableConfig.config.loading]])], 8, _hoisted_3)), [[_directive_loading, retryUploadRef.value && retryUploadRef.value.showLoading]]), _createVNode(_component_MDialog, {
        autoLoading: "",
        modelValue: dialogConfig.visible,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => dialogConfig.visible = $event),
        nativeConfig: {
          width: '400px',
          closeOnClickModal: false
        },
        dialogConfig: dialogConfig.config,
        onOnConfirm: dialogConfig.confirm,
        onOnClose: dialogConfig.close
      }, {
        default: _withCtx(() => [_withDirectives((_openBlock(), _createElementBlock("div", {
          style: {
            "width": "100%"
          },
          "element-loading-text": _unref(t)('文件MD5校验中 请稍后...')
        }, [_createVNode(_component_el_form, {
          ref_key: "uploadRef",
          ref: uploadRef,
          model: dialogConfig.formData
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            style: {
              "width": "100%"
            },
            prop: "file",
            rules: dialogConfig.rules.file
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_26, [_createElementVNode("div", null, [_createVNode(_component_el_button, {
              class: "el-button el-button--primary el-button--default",
              onClick: selectFile
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('选择文件')), 1)]),
              _: 1
            })]), _unref(chunkUploadRef).selectFile.length ? (_openBlock(), _createElementBlock("div", _hoisted_27, [_createVNode(_component_MPopper, {
              disabled: tipDisabled.value,
              placement: "top",
              trigger: "hover",
              content: _unref(chunkUploadRef).selectFile[0].fileName
            }, {
              reference: _withCtx(() => [_createElementVNode("span", {
                onMouseover: showTextTip,
                class: "pointer",
                style: {
                  "white-space": "nowrap",
                  "overflow": "hidden",
                  "text-overflow": "ellipsis"
                }
              }, _toDisplayString(_unref(chunkUploadRef).selectFile[0].fileName), 33)]),
              _: 1
            }, 8, ["disabled", "content"]), _createElementVNode("span", _hoisted_28, _toDisplayString(_unref(Uploader).utils.formatSize(_unref(chunkUploadRef).selectFile[0].fileSize)), 1), _createElementVNode("i", {
              class: "pointer iconfont icon-cuo tag__del",
              onClick: _cache[1] || (_cache[1] = //@ts-ignore
              (...args) => _unref(chunkUploadRef).clearSelectFile && _unref(chunkUploadRef).clearSelectFile(...args))
            })])) : _createCommentVNode("", true)])]),
            _: 1
          }, 8, ["rules"]), _createElementVNode("div", _hoisted_29, [_createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.$t('影片类型')), 1), _createVNode(_component_el_radio_group, {
            modelValue: dialogConfig.formData.programType,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => dialogConfig.formData.programType = $event)
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio, {
              label: "movie"
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('单片')), 1)]),
              _: 1
            }), _createVNode(_component_el_radio, {
              label: "tv_series"
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('剧集')), 1)]),
              _: 1
            })]),
            _: 1
          }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_31, [_createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.$t('信息源ID')), 1), _createVNode(_component_el_form_item, {
            style: {
              "width": "100%",
              "margin-bottom": "0"
            },
            prop: "sourceId"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: dialogConfig.formData.sourceId,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => dialogConfig.formData.sourceId = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          })])]),
          _: 1
        }, 8, ["model"])], 8, _hoisted_25)), [[_directive_loading, showUploadLoading.value]])]),
        _: 1
      }, 8, ["modelValue", "dialogConfig", "onOnConfirm", "onOnClose"]), _createVNode(_component_MDialog, {
        modelValue: searchDialogConfig.visible,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => searchDialogConfig.visible = $event),
        nativeConfig: {
          width: '70%',
          top: '5vh'
        },
        dialogConfig: searchDialogConfig.config,
        onOnConfirm: searchDialogConfig.confirm
      }, {
        default: _withCtx(() => [_createVNode(SearchDialog, {
          modelValue: searchDialogConfig.visible,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => searchDialogConfig.visible = $event),
          ref_key: "searchDialogRef",
          ref: searchDialogRef,
          options: options,
          "onUpdate:options": _cache[6] || (_cache[6] = $event => _isRef(options) ? options.value = $event : null),
          "program-type": dialogConfig.formData.programType
        }, null, 8, ["modelValue", "options", "program-type"])]),
        _: 1
      }, 8, ["modelValue", "dialogConfig", "onOnConfirm"])], 512), [[_vShow, !addTo.visible && !mediaDetail.visible]]), addTo.visible ? (_openBlock(), _createBlock(AddTo, {
        key: 0,
        onOnCancel: _cache[8] || (_cache[8] = $event => addTo.visible = false),
        "detail-info": {
          id: '',
          programType: 'movie',
          releaseStatus: ''
        },
        "add-type": "media",
        "media-params": mediaDetail.mediaParams,
        onUpdateList: updateList
      }, null, 8, ["media-params"])) : _createCommentVNode("", true), _createVNode(MediaDetail, {
        modelValue: mediaDetail.visible,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => mediaDetail.visible = $event),
        "detail-info": mediaDetail.detailInfo,
        onUpdateList: updateList
      }, null, 8, ["modelValue", "detail-info"])], 64);
    };
  }

});